"use client";

import Image from "next/image";
import Link from "next/link";
import { WORKS } from "@/lib/data";
import { Reveal } from "../Reveal";

export function Works() {
  return (
    <section className="px-5 py-24 md:px-8 md:py-32">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="mb-12 flex items-end justify-between">
            <h2 className="font-display text-4xl md:text-6xl">Façades signées.</h2>
            <Link href="/realisations" className="text-sm underline-offset-4 hover:underline">
              Galerie
            </Link>
          </div>
        </Reveal>
        <div className="grid gap-4 md:grid-cols-6">
          {WORKS.map((work, i) => (
            <Reveal
              key={work.title}
              delay={i * 0.05}
              className={i % 3 === 0 ? "md:col-span-4" : "md:col-span-2"}
            >
              <Link href="/realisations" className="group relative block aspect-4/3 overflow-hidden">
                <Image
                  src={work.image}
                  alt={`${work.title} — ${work.place}`}
                  fill
                  className="object-cover transition duration-700 group-hover:scale-105"
                  sizes="(min-width: 768px) 50vw, 100vw"
                />
                <div className="absolute inset-0 bg-ink/0 transition group-hover:bg-ink/35" />
                <div className="absolute inset-x-0 bottom-0 translate-y-3 p-5 text-paper opacity-0 transition group-hover:translate-y-0 group-hover:opacity-100">
                  <p className="font-display text-2xl">{work.title}</p>
                  <p className="text-sm text-sto">
                    {work.place} · {work.type}
                  </p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
